module.exports = __webpack_public_path__ + "static/media/4.b0058f3c.jpg";